import { useEffect, useRef, useState } from "react";
import "./SearchDropdown.css";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";

export const SearchDropdown = ({
    label,
    options,
    readOnly,
    onChange,
    value,
    className,
}) => {
    const [selected, setSelected] = useState(null);
    const [inputVal, setInputVal] = useState("");
    const [startTyping, setStartTyping] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [showDropdown, setShowDropDown] = useState(false);
    const ref = useRef(null);
    const searchref = useRef(null);
    const optionRef = useRef(null);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        if (value) {
            setSelected(value);
            setInputVal("");
        } else {
            setSelected(null);
        }
    }, [value]);

    useEffect(() => {
        setFilteredOptions(options);
    }, [options]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowDropDown(false);
                setStartTyping(false);
                setFilteredOptions(options);
                setInputVal("");
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [options]);

    useEffect(() => {
        if (showDropdown && scrollContainerRef.current && optionRef.current) {
            const targetPosition = optionRef.current.offsetTop;
            scrollContainerRef.current.scrollTop = targetPosition;
        }
    }, [showDropdown]);

    const renderSelectedValues = () => {
        return (
            <div className="search-label-handle">
                {!startTyping && (
                    <div className="d-flex align-item-start overflow-hidden">
                        <span className="selectedsearchText"> {selected}</span>
                    </div>
                )}
                <input
                    style={{ width: startTyping ? "87%" : "20px" }}
                    ref={searchref}
                    type="text"
                    value={inputVal ?? ""}
                    onChange={(e) => {
                        setStartTyping(true);
                        setInputVal(e.target.value ?? "");
                        const filteredOptionsLoc = options.filter((item) =>
                            item.value
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                        );
                        setFilteredOptions(filteredOptionsLoc);
                        setShowDropDown(true);
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowDropDown(true);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Backspace" && !startTyping) {
                            setStartTyping(true);
                        }
                    }}
                />
            </div>
        );
    };
    const renderSelectBox = () => {
        return (
            <div
                className={`searchdropdown-box-container ${(selected && selected.length > 0) ||
                        (inputVal && inputVal.length > 0)
                        ? "focussed"
                        : ""
                    }`}
                onClick={(e) => {
                    e.preventDefault();
                    if (searchref && searchref.current) {
                        searchref.current.focus();
                        const input = searchref.current;
                        input.setSelectionRange(
                            input.value.length,
                            input.value.length
                        );
                    }
                    setShowDropDown(!showDropdown);
                }}
            >
                <div className={`searchdropdown-selected-values-container`}>
                    {renderSelectedValues()}
                </div>

                <Text type={"body-text-2"} fontWeight={"normal-font"}>
                    {label}
                </Text>
                <div className={`searchdropdown-dropdown-icon-container`}>
                    <span
                        onClick={() => {
                            setStartTyping(false);
                            setFilteredOptions(options);
                        }}
                    >
                        <Icon
                            colorClass={"gray-900-svg"}
                            value={showDropdown ? "Chevron up" : "Chevron"}
                            hover={true}
                        />
                    </span>
                </div>
            </div>
        );
    };
    const renderDropDown = () => {
        if (showDropdown) {
            return (
                <div
                    className="searchdropdown-options"
                    ref={scrollContainerRef}
                    style={{
                        position: "absolute",
                        background: "#fff",
                        width: "200px",
                    }}
                >
                    {filteredOptions.map((option, index) => {
                        return (
                            <div
                                ref={option.value === selected ? optionRef : null}
                                key={"select-option" + index}
                                className={`searchdropdown-option ${option.value === selected
                                        ? "searchdropdown-option-disabled"
                                        : ""
                                    } `}
                                onClick={() => {
                                    if (option.value !== selected) {
                                        setShowDropDown(false);
                                        setStartTyping(false);
                                        setInputVal("");
                                        setSelected(option.value);
                                        if (onChange) {
                                            onChange(option.value);
                                        }
                                        setFilteredOptions(options);
                                    }
                                }}
                            >
                                <div className="d-flex align-item-start justify-content-between">
                                    <span className="searchboxText">{option.value}</span>
                                    <span className="searchboxIcons">{option.prefix_label}</span>
                                </div>
                            </div>
                        );
                    })}
                    {filteredOptions.length === 0 && (
                        <div
                            key={"select-option"}
                            className="searchdropdown-option"
                        >
                            No data found.
                        </div>
                    )}
                </div>
            );
        }
        return <></>;
    };
    return (
        <div
            ref={ref}
            className={`searchdropdown-box position-relative ${className ? className : ""
                } ${readOnly ? "searchdropdown-readonly" : ""}`}
        >
            {renderSelectBox()}
            {renderDropDown()}
        </div>
    );
};
